export default "__VITE_ASSET__703e3307__"